export const getLocationList = () => {
    try {
        const locationList = localStorage.getItem('locationList');
        
        if (locationList) {
            return JSON.parse(locationList);
        }
        return [];
        
    } catch (error) {
        console.error('Error getting location list:', error);
        return [];
    }
};

export const getLocation = (locId) => {
    
    return locId && locId == "1" ? "Chennai" : (locId == "2" ? "Trichy" : "0");
}
